export default "<p>custom-dashboard-list works!</p>\n"